import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsAllSides: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsAllSides"><Path d="M9 5.75L12 2.75L15 5.75M5.75 9L2.75 12L5.75 15M18.25 9L21.25 12L18.25 15M15 18.25L12 21.25L9 18.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowsAllSides;
